import styled from '@emotion/styled';
import { ClassAttributes, createElement } from 'react';

import { SPACING_REGULAR, SPACING_UNIT } from '../../constant/spacing';
import { gridLayoutContainer, gridLayoutItem } from '../../styleUtility/gridLayout';
import AspectRatioFixed from '../primitive/AspectRatioFixed';
import DummyContent from '../primitive/DummyContent';
import DummyRectangle from '../primitive/DummyRectangle';
import DummyAvatarAndName from './DummyAvatarAndName';

interface Props extends ClassAttributes<HTMLElement> {
  className?: string;
}

const DummyDeliverableDetail = ({ className }: Props) => {
  return (
    <Root className={className}>
      <DummyOptimizer />

      <DummyId size="caption" align="right" length={50} />

      <DummyVideo aspectRatio={[4, 3]}>
        <DummyRectangle />
      </DummyVideo>

      <DummyDownloadButton />

      <DummyIntentHeading size="h6" />

      <DummyIntent size="body2" length={450} />
    </Root>
  );
};

const Root = styled('div')(
  gridLayoutContainer({
    columns: ['2fr', '2fr', `${SPACING_UNIT * 3}px`, '3fr'],
    rows: ['auto', 'auto', '1fr', 'auto'],
    areas: [
      ['optimizer', 'idAndCreatedAt', '.', 'createdAt'],
      ['video', 'video', '.', 'intentHeading'],
      ['video', 'video', '.', 'intentBody'],
      ['.', 'downloadButton', '.', 'intentBody'],
    ],
  }),
);

const DummyOptimizer = styled(DummyAvatarAndName)(gridLayoutItem('optimizer'), { marginBottom: SPACING_REGULAR });

const DummyId = styled(DummyContent)(
  gridLayoutItem('idAndCreatedAt', {
    alignSelf: 'flex-end',
    justifySelf: 'flex-end',
  }),
  { marginBottom: SPACING_REGULAR },
);

const DummyVideo = styled(AspectRatioFixed)(gridLayoutItem('video'), { marginBottom: SPACING_REGULAR });

const DummyDownloadButton = styled(DummyRectangle)(gridLayoutItem('downloadButton', { justifySelf: 'flex-end' }), {
  width: 144,
  height: 36,
});

const DummyIntentHeading = styled(DummyContent)(gridLayoutItem('intentHeading'), { marginBottom: SPACING_UNIT });

const DummyIntent = styled(DummyContent)(gridLayoutItem('intentBody'));

export default DummyDeliverableDetail;
